
export const API_URL = process.env.NODE_ENV === "development" ? "http://localhost:3001/api" : "https://draumadeildin.is/api";
